import { Flex } from "Element/Flex";
import {
  Box,
  BoxContainer,
  ButtonWrapper,
  StyledDesc,
  StyledTitle,
} from "./styled";

interface Props {
  title: string;
  desc: string;
  btn1: JSX.Element;
  btn2?: JSX.Element;
}

const InvitationBox = ({ title, desc, btn1, btn2 }: Props) => {
  return (
    <BoxContainer>
      <Box alignItems="center" justifyContent="space-between">
        <Flex flexDirection="column">
          <StyledTitle>{title}</StyledTitle>
          <StyledDesc>{desc}</StyledDesc>
        </Flex>
        <ButtonWrapper flexDirection="column">
          {btn1}
          {btn2}
        </ButtonWrapper>
      </Box>
    </BoxContainer>
  );
};

export default InvitationBox;
